"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evalScript = void 0;
var Machine_1 = require("./Machine/Machine.js");
/**
 * @deprecated use `Machine.evalSimple` static method instead
 */
function evalScript(term) {
    return Machine_1.Machine.evalSimple(term);
}
exports.evalScript = evalScript;
